import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { Titulo } from '../_models/titulo/titulo';
import { FilterTitulo } from '../_models/filter/filterTitulo';
import { PageDTO } from '../_models/titulo/pageDTO';

export const HTTP_OPTIONS = {
headers: new HttpHeaders({
  'Content-Type':  'application/json',
  'Access-Control-Allow-Credentials' : 'true',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
  'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
})
};

@Injectable({ providedIn: 'root' })
export class TituloService {
  constructor(private http: HttpClient) { }

  pesquisarTitulo(filterTitulo: FilterTitulo): Observable<any> {
      return this.http.post<Titulo[]>(`${environment.authorizedUrls.bsCobrancaUrl}/titulo/listFiltro`, {
      filterTitulo, HTTP_OPTIONS
    });
  }

  pesquisarTituloPageable(filterTitulo: FilterTitulo): Observable<any> {
      return this.http.post<PageDTO>(`${environment.authorizedUrls.bsCobrancaUrl}/titulo/filtro`, {
      filterTitulo, HTTP_OPTIONS
    });
  }

  getExportTitulo(filterTitulo: FilterTitulo): Observable<Blob> {
    return this.http.post(`${environment.authorizedUrls.bsCobrancaUrl}/titulo/exportTitulo/`,  {
      filterTitulo, HTTP_OPTIONS
    }, {responseType: 'blob'});
  }

  exportarRelatorioTitulos(filterTitulo: FilterTitulo){
    return this.http.post(`${environment.authorizedUrls.bsCobrancaUrl}/titulo/exportarTitulos`, {
        filterTitulo
    }, {responseType: 'blob' as 'json'})

  }

}
